<template>
  <div class="lxn-w100">
    <TitleBox :titleBgColor="titleBgColor" :bgColor="bgColor">
      <template v-slot:title>
        {{title ? title : $store.getters.language.texts.CommandCreator_title2}}
      </template>
      <template  v-slot:body>
        <div  v-for="(command, index) in generatedCommand" :key="index" class="CommandCreator-wrapper-commands lxn-w100 lxn-border-round lxn-overflow-hidden lxn-pos-rel">
          <div class="CommandCreator-wrapper-commands-trash lxn-pos-abs" :class="trashIconClass">
            <ButtonIcon @click="generatedCommand.splice(index, 1)" :size="30" bgColor="#F36C4F" icon="x" iconColor="#FFFFFF" :padding="8" />
          </div>
          <div class="CommandCreator-wrapper-command lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            <div :class="$store.getters.language.floatClass">
              {{command.hub.name}}
            </div>
            <div :class="$store.getters.language.floatClass">
              &nbsp;>&nbsp;
            </div>
            <div v-if="!showAutomations" :class="$store.getters.language.floatClass">
              {{command.node.name}}
            </div>
            <div v-else :class="$store.getters.language.floatClass">
              {{command.widget.name}}
            </div>
            <div v-if="!showAutomations" :class="$store.getters.language.floatClass">
              &nbsp;>&nbsp;
            </div>
            <div v-if="!showAutomations && !showInputs" :class="$store.getters.language.floatClass">
              {{command.output.name}}
            </div>
            <div v-else-if="!showAutomations" :class="$store.getters.language.floatClass">
              {{command.notificationTypeText}}&nbsp;{{command.input.name}}
            </div>
          </div>
          <div v-if="showInputs" class="CommandCreator-wrapper-command2 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            <div class="lxn-float-right">
              <SingleSwitch :state="command.state" bgColorOn="#00AEEF" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
            </div>
            <!-- <div v-if="!showAutomations && !showCreateCommand" class="CommandCreator-wrapper-commandDelay lxn-float-left">
              {{$store.getters.language.texts.CommandCreator_delayTitle}} : 
              {{command.delay}}
              {{$store.getters.language.texts.CommandCreator_delaySecond}}
            </div> -->
            <div class="CommandCreator-wrapper-commandDelay lxn-float-left">
              &nbsp;
            </div>
          </div>
          <div v-else-if="showAutomations || (command.output.type != 'IrDevice' && command.output.type != 'RfDevice')" class="CommandCreator-wrapper-command2 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            <div class="lxn-float-right">
              <SingleSwitch :state="command.state" bgColorOn="#00AEEF" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
            </div>
            <div v-if="!showAutomations && !showCreateCommand" class="CommandCreator-wrapper-commandDelay lxn-float-left">
              {{$store.getters.language.texts.CommandCreator_delayTitle}} : 
              {{command.delay}}
              {{$store.getters.language.texts.CommandCreator_delaySecond}}
            </div>
            <div v-else class="CommandCreator-wrapper-commandDelay lxn-float-left">
              &nbsp;
            </div>
          </div>
          <div v-if="!showInputs && command.output.type == 'IrDevice'" class="lxn-w100">
            <AcRemoteControllerLCD :targetFan="command.state.targetFan" :targetTemperature="command.state.targetTemperature" :targetMode="command.state.targetMode" />
            <div class="CommandCreator-wrapper-command lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              <div class="lxn-float-right">
              </div>
              <div class="CommandCreator-wrapper-commandDelay lxn-float-left">
                {{$store.getters.language.texts.CommandCreator_delayTitle}} : 
                {{command.delay}}
                {{$store.getters.language.texts.CommandCreator_delaySecond}}
              </div>
            </div>
          </div>
          <div v-if="!showInputs && command.output.type == 'RfDevice'" class="lxn-w100">
            <div class="lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_selectedChannel}} : 
              {{$store.getters.language.texts.CommandCreator_channel}} 
              {{command.state.rfChannel + 1}}
            </div>
            <div class="CommandCreator-wrapper-command lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              <div class="lxn-float-right">
              </div>
              <div class="CommandCreator-wrapper-commandDelay lxn-float-left">
                {{$store.getters.language.texts.CommandCreator_delayTitle}} : 
                {{command.delay}}
                {{$store.getters.language.texts.CommandCreator_delaySecond}}
              </div>
            </div>
          </div>
        </div>
        <div class="CommandCreator-wrapper-button2 lxn-margin-auto">
          <CustomButton @click="showCreateCommandBox()" :bgColor="titleBgColor" iconRight="plus" :iconRightColor="titleBgColor" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
            {{$store.getters.language.texts.CommandCreator_button2}}
          </CustomButton>
        </div>
        <TitleBox v-if="showCreateCommand" :titleBgColor="titleBgColor" :bgColor="bgColor">
          <template v-slot:title>
            {{$store.getters.language.texts.CommandCreator_title3}}
          </template>
          <template v-slot:body>
            <div v-if="!noHubSelect" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text5}}
            </div>
            <div v-if="!noHubSelect" class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
            <div v-if="showAutomations" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text10}}
            </div>
            <div v-else-if="showInputs" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text12}}
            </div>
            <div v-else class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text2}}
            </div>
            <div v-if="showInputs" class="lxn-w100">
              <DropDown v-model="targetInput" :dropDownContex="dropDownTargetInputs" />
            </div>
            <div v-else class="lxn-w100">
              <DropDown v-model="targetOutput" :dropDownContex="dropDownTargetOutputs" />
            </div>
            <div v-if="showAutomations" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text11}}
            </div>
            <div v-else-if="showInputs" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text14}}
            </div>
            <div v-else class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text3}}
            </div>
            <div v-if="!isSelectedOutputIR && !isSelectedOutputRF" class="CommandCreator-wrapper-fieldTitles lxn-w100">
              <div class="lxn-display-table lxn-margin-auto">
                <SingleSwitch @switchClicked="toggleSwitchState()" :state="switchState" bgColorOn="#00AEEF" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
              </div>
            </div>
            <!-- <div v-if="showInputs" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.CommandCreator_text15}}
            </div>
            <div v-if="showInputs" class="lxn-display-table lxn-margin-auto">
              <SingleSwitch @switchClicked="toggleNotifState()" :state="notifOnConnect" bgColorOn="#00AEEF" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
            </div> -->
            <div v-if="isSelectedOutputIR" class="lxn-w100">
              <AcRemoteController v-model="acCommandContex" :nodeUUID="irNodeUUID" :outputIndex="irOutputIndex" :sendCommand="false" />
            </div>
            <div v-if="isSelectedOutputRF" class="lxn-w100">
              <DropDown v-model="targetRfCommand" :dropDownContex="dropDownTargetRfCommand" />
            </div>
            <div v-if="!isSelectedOutputIR && !isSelectedOutputRF && !showAutomations && !showInputs" class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.CommandCreator_text4}}
            </div>
            <div v-if="!isSelectedOutputIR && !isSelectedOutputRF && !showAutomations && !showInputs" class="lxn-w100 lxn-overflow-hidden">
              <NumberInputSpinner :min="0" :max="65535" :step="1" :integerOnly="true" v-model="commandDelay" buttonClass="CommandCreator-commandDelay-button" />
            </div>
            <div class="CommandCreator-wrapper-button2 lxn-margin-auto">
              <CustomButton @click="addCommand" :bgColor="titleBgColor" iconRight="plus" :iconRightColor="titleBgColor" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
                {{$store.getters.language.texts.CommandCreator_button3}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </template>
    </TitleBox>
  </div>
</template>

<script>

import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomButton from '@/components/CustomButton.vue'
import DropDown from '@/components/DropDown.vue'
import AcRemoteController from '@/components/Home/Devices/AcRemoteController.vue'
import AcRemoteControllerLCD from '@/components/Home/Devices/AcRemoteControllerLCD.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import SingleSwitch from '@/components/SingleSwitch.vue'
import TitleBox from '@/components/TitleBox.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'CommandCreator',
  props: {
    title: String,
    titleBgColor: String,
    multiHub: Boolean,
    outputsOnly: {
      type: Boolean,
      default: true
    },
    showAutomations: {
      type: Boolean,
      default: false
    },
    showInputs: {
      type: Boolean,
      default: false
    },
    loadFrom: Array,
    commandToLoad: Object,
    noHubSelect: Boolean,
    hubIndex: {
      type: Number,
      default: 0
    },
    bgColor: {
      type: String,
      default: "#ECECEC",
    }
  },
  components: {
    TitleBox,
    NumberInputSpinner,
    DropDown,
    CustomButton,
    ButtonIcon,
    SingleSwitch,
    AcRemoteController,
    AcRemoteControllerLCD
  },
  data: function () {
    return {
      generatedCommand: [],
      outputList: [],
      inputList: [],
      commandDelay: 0,
      targetHub: this.hubIndex,
      targetOutput: 0,
      targetInput: 0,
      switchState: 'on',
      notifOnConnect : "on", 
      acCommandContex: 0,
      targetRfCommand: 0,
      isSelectedOutputIR: false,
      isSelectedOutputRF: false,
      showCreateCommand: false,
    }
  },
  mounted: function () {
    //trigger dropDownTargetOutputs
    this.dropDownTargetOutputs;
    if(this.$store.state.hubs.length != 0){
      if(!this.showAutomations){
        if(this.outputList.length != 0){
          if(this.outputList[this.targetOutput].output.type == "IrDevice"){
            this.isSelectedOutputIR = true;
            this.isSelectedOutputRF = false;
          }else if(this.outputList[this.targetOutput].output.type == "RfDevice"){
            this.isSelectedOutputRF = true;
            this.isSelectedOutputIR = false;
          }else{
            this.isSelectedOutputIR = false;
            this.isSelectedOutputRF = false;
          }
        }
      }
    }else{
      alert(this.$store.getters.language.texts.CommandCreator_alertNoHubs);
      this.$router.go(-1);
    }

    if(this.commandToLoad){
      if(!this.showAutomations && !this.showInputs){
        var generatedCommand = [{
          hubUUID: this.commandToLoad.hubUUID,
          actions: [],
        }];
        var nodesActions = messaging.commandDeserializer(this.commandToLoad.command);
        nodesActions.forEach(nodeActions => {
          var node = this.$store.getters.getNodeByUUID(nodeActions.nodeUUID);
          nodeActions.actions.forEach(action => {
            var output = node.outputs.find(output => output.parameterId == action.parameterId);
            action = {
              nodeUUID: nodeActions.nodeUUID,
              outputType: output.type,
              parameterId: action.parameterId,
              timeDelay: action.timeDelay,
              typeOfAction: action.typeOfAction,
              valueOfChange: action.valueOfChange,
            }
            if(output.type == 'IrDevice'){
              var irDevice = this.getIrDeviceByCommand(action.valueOfChange);
              if(irDevice){
                action.outputSettings = {
                  brand: irDevice.brandIndex,
                  deviceType: irDevice.deviceTypeIndex,
                  model: irDevice.deviceIndex,
                }
                action.state = {
                  targetCommandIndex: irDevice.commandPackIndex,
                  targetFan: irDevice.commandPack.fan,
                  targetMode: irDevice.commandPack.mode,
                  targetTemperature: irDevice.commandPack.temperature,
                }
                generatedCommand[0].actions.push(action);
              }
            }else if(output.type == 'RfDevice'){
              // var rfDevice = this.getRfDeviceByCommand(action.valueOfChange);
              // if(rfDevice){
              //   action.state = {
              //     rfChannel: rfDevice.channel???,
              //     rfCommand: rfDevice.command???,
              //   }
              //   generatedCommand[0].actions.push(action);
              // }
            }else{
              action.state = action.valueOfChange ? 'on' : 'off';
              generatedCommand[0].actions.push(action);
            }
          });
        });
        this.generatedCommand = this.generateLoadableCommands(generatedCommand);
      }else if (!this.showInputs){
        var eventMasks = messaging.setEventMasksDeserializer(this.commandToLoad.command);
        eventMasks = eventMasks.maskList;

        var hub = this.$store.getters.getHubByUUID(this.commandToLoad.hubUUID);
        generatedCommand = [];

        eventMasks.forEach(eventMask => {
          var eventId = eventMask.eventId;
          var groupId = (eventId & 0xff) >> 3;
          var state = eventMask.isMasked ? 'off' : 'on';
          var widget = this.$store.getters.getTemperatureAutomationWidgetByGroupId(groupId);
          if(!generatedCommand.find(command => command.widgetIndex == widget.index)){
            generatedCommand.push({
              hub: hub,
              widget: widget,
              widgetIndex: widget.index,
              state: state,
              output: {
                type: ''
              }
            });
          }
        });
        this.generatedCommand = generatedCommand;
      } else {
        let eventMasks = messaging.setEventMasksDeserializer(this.commandToLoad.command);
        eventMasks = eventMasks.maskList;

        let hub = this.$store.getters.getHubByUUID(this.commandToLoad.hubUUID);
        generatedCommand = [];

        eventMasks.forEach(eventMask => {
          var eventId = eventMask.eventId;
          var state = eventMask.isMasked ? 'off' : 'on';
          var notification = this.$store.getters.getNotificationByEventId(eventId);
          let notificationTypeText = notification.notifyOnconnect == true ? this.$store.getters.language.texts.CommandCreator_text16 : this.$store.getters.language.texts.CommandCreator_text17
          if(!generatedCommand.find(command => command.widgetIndex == notification.index)){
            generatedCommand.push({
              hub: hub,
              notificationIndex: notification.index,
              state: state,
              node: this.$store.getters.getNodeByUUID(notification.nodeUUID),
              input: notification.input,
              output: undefined,
              notificationTypeText:notificationTypeText,
            });
          }
        });
        this.generatedCommand = generatedCommand;
      }
    }
  },
  watch: {
    hubIndex: function (newVal) {
      this.targetHub = newVal;
    },
    loadFrom: function (newVal) {
      if(newVal != undefined){
        this.generatedCommand = newVal;
      }
    },
    targetHub: function (){
      if(!this.multiHub){
        this.generatedCommand = [];
      }

      this.targetOutput = 0;
      //trigger dropDownTargetOutputs
      this.dropDownTargetOutputs;

      if(!this.showAutomations){
        if(this.outputList[this.targetOutput].output.type == "IrDevice"){
          this.isSelectedOutputIR = true;
          this.isSelectedOutputRF = false;
        }else if(this.outputList[this.targetOutput].output.type == "RfDevice"){
          this.isSelectedOutputRF = true;
          this.isSelectedOutputIR = false;
        }else{
          this.isSelectedOutputIR = false;
          this.isSelectedOutputRF = false;
        }
      }else{
        this.isSelectedOutputIR = false;
        this.isSelectedOutputRF = false;
      }
    },
    showAutomations: function () {
      this.generatedCommand = [];
      this.targetOutput = 0;
      //trigger dropDownTargetOutputs
      this.dropDownTargetOutputs;

      if(!this.showAutomations){
        if(this.outputList[this.targetOutput].output.type == "IrDevice"){
          this.isSelectedOutputIR = true;
          this.isSelectedOutputRF = false;
        }else if(this.outputList[this.targetOutput].output.type == "RfDevice"){
          this.isSelectedOutputRF = true;
          this.isSelectedOutputIR = false;
        }else{
          this.isSelectedOutputIR = false;
          this.isSelectedOutputRF = false;
        }
      }else{
        this.isSelectedOutputIR = false;
        this.isSelectedOutputRF = false;
      }
    },
    targetOutput: function (newVal) {
      if(this.showAutomations){
        this.isSelectedOutputIR = false;
        this.isSelectedOutputRF = false;  
      }else if (!this.showInputs){
        if(this.outputList[newVal].output.type == "IrDevice"){
          this.isSelectedOutputIR = true;
          this.isSelectedOutputRF = false;
        }else if(this.outputList[newVal].output.type == "RfDevice"){
          this.isSelectedOutputRF = true;
          this.isSelectedOutputIR = false;
        }else{
          this.isSelectedOutputIR = false;
          this.isSelectedOutputRF = false;
        }
      }
    },
    targetInput: function (newVal) {
      console.log("targetInput watcher fired");
    },
    generatedCommandPacketLength: function (newVal) {
      if(!this.showAutomations){
        if(newVal > CONFIGS.MAX_LORA_PACKET_SIZE){
          alert(this.$store.getters.language.texts.CommandCreator_alertPacketOverflow);
          this.generatedCommand.pop();
        }
      }else{
        if(newVal > CONFIGS.MAX_IMITATOR_PACKET_SIZE){
          alert(this.$store.getters.language.texts.CommandCreator_alertPacketOverflow);
          this.generatedCommand.pop();
        }
      }
    },
    generatedCommand: function (newVal) {
      var commandToEmit = [];
      var generatedCommand = newVal;
      for(var i = 0; i < newVal.length; i++){
        if(!this.showAutomations && !this.showInputs){
          var hubIsNew = true;

          var typeOfAction = 0;
          var valueOfChange = 0;

          if(generatedCommand[i].output.type != 'IrDevice' && generatedCommand[i].output.type != 'RfDevice'){
            if(generatedCommand[i].state == 'on'){
              typeOfAction = CONFIGS.ACTION_TYPE_SET;
              valueOfChange = 1;
            }else if(generatedCommand[i].state == 'off'){
              typeOfAction = CONFIGS.ACTION_TYPE_SET;
              valueOfChange = 0;
            }
          }else if(generatedCommand[i].output.type == 'IrDevice') {
            var irOutput = generatedCommand[i].output;
            var deviceType = irOutput.settings.deviceType;
            var brand = irOutput.settings.brand;
            var model = irOutput.settings.model;
            var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

            valueOfChange = messaging.utility.arrayTo128(irDevice.commands[generatedCommand[i].state.targetCommandIndex].command);
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
          }else if(generatedCommand[i].output.type == 'RfDevice') {
            valueOfChange = messaging.utility.arrayTo64(generatedCommand[i].state.rfCommand);
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
          }
          var action = {
            nodeUUID: generatedCommand[i].node.uuid,
            parameterId: generatedCommand[i].output.parameterId,
            valueOfChange: valueOfChange,
            typeOfAction: typeOfAction,
            state: generatedCommand[i].state,
            outputSettings: generatedCommand[i].output.settings,
            outputType: generatedCommand[i].output.type,
            timeDelay: generatedCommand[i].delay
          }

          for(var j = 0; j < commandToEmit.length; j++){
            if(newVal[i].hub.uuid == commandToEmit[j].hubUUID){
              commandToEmit[j].actions.push(action);
              hubIsNew = false;
              break;
            }
          }
          if(hubIsNew){
            commandToEmit.push({
              hubUUID: generatedCommand[i].hub.uuid,
              actions: [action],
            })
          }
        }else if (this.showAutomations){
          hubIsNew = true;

          var maskList = [];

          //eventId for cool on
          var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (generatedCommand[i].widget.settings.groupId & 0xFF) << 3);
          //eventId for cool off
          var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (generatedCommand[i].widget.settings.groupId & 0xFF) << 3) + 1;
          //eventId for heat on
          var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (generatedCommand[i].widget.settings.groupId & 0xFF) << 3) + 2;
          //eventId for heat off
          var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (generatedCommand[i].widget.settings.groupId & 0xFF) << 3) + 3;

          if(generatedCommand[i].state == "on") {
            maskList.push({
              eventId: coolOnActualEventId,
              isMasked: false,
            });
            maskList.push({
              eventId: coolOffActualEventId,
              isMasked: false,
            });
            maskList.push({
              eventId: heatOnActualEventId,
              isMasked: false,
            });
            maskList.push({
              eventId: heatOffActualEventId,
              isMasked: false,
            });
          }else{
            maskList.push({
              eventId: coolOnActualEventId,
              isMasked: true,
            });
            maskList.push({
              eventId: coolOffActualEventId,
              isMasked: true,
            });
            maskList.push({
              eventId: heatOnActualEventId,
              isMasked: true,
            });
            maskList.push({
              eventId: heatOffActualEventId,
              isMasked: true,
            });
          }
          for(j = 0; j < commandToEmit.length; j++){
            if(newVal[i].hub.uuid == commandToEmit[j].hubUUID){
              commandToEmit[j].maskList.push(maskList[0]);
              commandToEmit[j].maskList.push(maskList[1]);
              commandToEmit[j].maskList.push(maskList[2]);
              commandToEmit[j].maskList.push(maskList[3]);
              hubIsNew = false;
              break;
            }
          }
          if(hubIsNew){
            commandToEmit.push({
              hubUUID: generatedCommand[i].hub.uuid,
              maskList: maskList,
            })
          }
        } else {
          let notifications = this.$store.state.notifications;
          let maskList = [];
          let hubIsNew = true;
          for (let notifIndex in notifications) {
            let notif = notifications[notifIndex];
            // console.log("notif", notif);
            // console.log("generatedCommand[i]", generatedCommand[i]);
            // console.log("generatedCommand[i]", notif.hubUUID,  generatedCommand[i].hub.uuid);
            // console.log("generatedCommand[i]", notif.nodeUUID , generatedCommand[i].node.Uuid);
            // console.log("generatedCommand[i]", notif.input.parameterId == generatedCommand[i].input.parameterId);
            if (notif.hubUUID == generatedCommand[i].hub.uuid && notif.nodeUUID == generatedCommand[i].node.uuid && notif.input.parameterId == generatedCommand[i].input.parameterId){
              if(generatedCommand[i].state == "on") {
                maskList.push({
                  eventId: notif.eventId,
                  isMasked: false,
                });
              }else {
                maskList.push({
                  eventId: notif.eventId,
                  isMasked: true,
                });
              }
              for(j = 0; j < commandToEmit.length; j++){
                if(newVal[i].hub.uuid == commandToEmit[j].hubUUID){
                  commandToEmit[j].maskList.push(maskList[0]);
                  hubIsNew = false;
                  break;
                }
              }
              if(hubIsNew){
                commandToEmit.push({
                  hubUUID: generatedCommand[i].hub.uuid,
                  maskList: maskList,
                })
              }
            }
          }
        }
      }
      this.$emit('input', commandToEmit);
    },
  },
  computed: {
    trashIconClass: function () {
      if(this.$store.getters.language.texts.isRTL){
        return 'left';
      }else{
        return 'right';
      }
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "CommandCreator-TargetHubs",
        title: this.$store.getters.language.texts.CommandCreator_text5,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetRfCommand: function () {
      var dropDownTargetRfCommand = {
        name: "CommandCreator-TargetRfCommand",
        title: this.$store.getters.language.texts.CommandCreator_textTargetRfCommand,
        selectedIndex: this.targetRfCommand,
        data: []
      };
      for(var i = 1; i < 5; i++){
        dropDownTargetRfCommand.data.push({
          name: this.$store.getters.language.texts.CommandCreator_channel + " " + i,
          icon: "remoteControl",
        })
      }
      return dropDownTargetRfCommand;
    },
    dropDownTargetOutputs: function () {
      this.outputListCleaner();
      this.inputListCleaner();
      var dropDownTargetOutputs = {
        name: "Scenario-TargetOutputs",
        title: this.$store.getters.language.texts.CommandCreator_text2,
        selectedIndex: this.targetOutput,
        data: []
      };
      if(!this.showAutomations){
        for(var i = 0; i < this.$store.state.nodes.length; i++){
          if(this.$store.state.hubs[this.targetHub].uuid == this.$store.state.nodes[i].hubUUID){
            for(var j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
              this.outputListSetter(
                {
                  node: this.$store.state.nodes[i],
                  output: this.$store.state.nodes[i].outputs[j],
                  outputIndex: j,
                }
              );
              dropDownTargetOutputs.data.push({
                name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].outputs[j].name,
                icon: this.$store.state.nodes[i].outputs[j].icon,
              })
            }
          }
        }
      }else{
        for(i = 0; i < this.$store.state.widgets.length; i++){
          if(this.$store.state.hubs[this.targetHub].uuid == this.$store.state.widgets[i].hubUUID){
            if(this.$store.state.widgets[i].type == "temperatureAutomationWidget"){
              this.outputListSetter(
                {
                  widget: this.$store.state.widgets[i],
                  widgetIndex: i,
                }
              );
              dropDownTargetOutputs.data.push({
                name: this.$store.state.widgets[i].name,
                icon: 'auto',
              })
            }
          }
        }
      }
      this.$store.state.hubs.map(x => [...(x.outputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        this.outputListSetter(
            {
              node: x.node,
              output: x.output,
              outputIndex: j,
            }
        );
        dropDownTargetOutputs.data.push({
          name: x.node.name + ' > ' + x.output.name,
          icon: "hub",
        })
      });
      return dropDownTargetOutputs;
    },
    dropDownTargetInputs: function () {
      this.outputListCleaner();
      this.inputListCleaner();
      var dropDownTargetInputs = {
        name: "Scenario-TargetInputs",
        title: this.$store.getters.language.texts.CommandCreator_text13,
        selectedIndex: this.targetInput,
        data: []
      };
      for(var i = 0; i < this.$store.state.notifications.length; i++){
        let notification = this.$store.state.notifications[i]
        if(this.$store.state.hubs[this.targetHub].uuid == notification.hubUUID){
          let node = this.$store.getters.getNodeByUUID(notification.nodeUUID)
          let inputIndex = node.inputs.findIndex(input => {
            if (input.parameterId == notification.input.parameterId){
              return true;
            } else {
              return false;
            }
          })
          let notificationTypeText = notification.notifyOnconnect == true ? this.$store.getters.language.texts.CommandCreator_text16 : this.$store.getters.language.texts.CommandCreator_text17
          this.inputListSetter(
            {
              node: node,
              input: node.inputs[inputIndex],
              inputIndex: inputIndex,
              notificationTypeText: notificationTypeText,
              notificationIndex: i
            }
          ); 

          dropDownTargetInputs.data.push({
            name:  this.$store.state.nodes[i].name + ' > ' + `${notificationTypeText} ${node.inputs[inputIndex].name}` ,
            icon: node.inputs[inputIndex].icon,
          })
          
        }
      }

      return dropDownTargetInputs;
    },    
    irNodeUUID: function () {
      return this.outputList[this.targetOutput].node.uuid;
    },
    irOutputIndex: function () {
      return this.outputList[this.targetOutput].outputIndex;
    },
    generatedCommandPacketLength: function () {
      if(this.$store.state.hubs.length != 0 && !this.multiHub){
        if(!this.showAutomations && !this.showInputs){
          var nodeActions = [];
          var typeOfAction = 0;
          var valueOfChange = 0;
          var isNodeNew = true;
          for(var i = 0; i < this.generatedCommand.length; i++){
            isNodeNew = true;
            if(this.generatedCommand[i].output.type != 'IrDevice' && this.generatedCommand[i].output.type != 'RfDevice'){
              if(this.generatedCommand[i].state == 'on'){
                typeOfAction = CONFIGS.ACTION_TYPE_SET;
                valueOfChange = 1;
              }else if(this.generatedCommand[i].state == 'off'){
                typeOfAction = CONFIGS.ACTION_TYPE_SET;
                valueOfChange = 0;
              }
            }else if(this.generatedCommand[i].output.type == 'IrDevice') {
              var irOutput = this.generatedCommand[i].output;
              var deviceType = irOutput.settings.deviceType;
              var brand = irOutput.settings.brand;
              var model = irOutput.settings.model;
              var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

              valueOfChange = messaging.utility.arrayTo128(irDevice.commands[this.generatedCommand[i].state.targetCommandIndex].command);
              typeOfAction = CONFIGS.ACTION_TYPE_SET;
            }else if(this.generatedCommand[i].output.type == 'RfDevice') {
              valueOfChange = messaging.utility.arrayTo64(this.generatedCommand[i].state.rfCommand);
              typeOfAction = CONFIGS.ACTION_TYPE_SET;
            }
            var action = {
              parameterId: this.generatedCommand[i].output.parameterId,
              valueOfChange: valueOfChange,
              typeOfAction: typeOfAction,
              timeDelay: this.generatedCommand[i].delay
            }
            for(var j = 0; j < nodeActions.length; j++){
              if(nodeActions[j].nodeUUID == this.generatedCommand[i].node.uuid){
                nodeActions[j].actions.push(action);
                isNodeNew = false;
                break;
              }
            }
            if(isNodeNew){
              nodeActions.push(
                {
                  nodeUUID: this.generatedCommand[i].node.uuid,
                  actions: [action]
                }
              );
            }
          }
          var hub = this.$store.state.hubs[this.targetHub];
          var commandToSend = [];
          var messagingHook = new Messaging(new Logger(false));
          var psk = hub.psk;
          var destinationUUID = hub.uuid;
          messagingHook.init({
            psk: psk,
            destinationUUID: destinationUUID,
            sourceUUID: this.$store.state.user.uuid
          });
          messagingHook.setParametersOfNodesSerializer(commandToSend, {nodeActions: nodeActions});
          return commandToSend.length;
        }else if (this.showAutomations){
          //packet type + mask count + (event Id + isMasked)*event count*4
          return this.generatedCommand.length*3*4 + 2;
        } else {
          return this.generatedCommand.length*3 + 2;
        }
      }else{
        return 0;
      }
    },
  },
  methods: {
    outputListSetter: function (obj) {
      this.outputList.push(obj);
    },
    inputListSetter: function (obj) {
      this.inputList.push(obj);
    },
    outputListCleaner: function () {
      this.outputList = [];
    },
    inputListCleaner: function () {
      this.inputList = [];
    },
    toggleSwitchState: function () {
      if(this.switchState == 'on'){
        this.switchState = 'off';
      }else{
        this.switchState = 'on';
      }
    },
    toggleNotifState: function () {
      if(this.notifOnConnect == 'on'){
        this.notifOnConnect = 'off';
      }else{
        this.notifOnConnect = 'on';
      }
    },
    showCreateCommandBox: function () {
      this.showCreateCommand = true;
    },
    generateLoadableCommands: function (commandContex) {
      var loadedCommand = [];
      for(var i = 0; i < commandContex.length; i++){
        for(var j = 0; j < commandContex[i].actions.length; j++){
          var hub = this.$store.getters.getHubByUUID(commandContex[i].hubUUID);
          var node = this.$store.getters.getNodeByUUID(commandContex[i].actions[j].nodeUUID);
          var state = commandContex[i].actions[j].state;
          var delay = commandContex[i].actions[j].timeDelay;
          var output = null;
          var outputFound = false;
          if(commandContex[i].actions[j].outputType == "IrDevice"){
            for(var k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].settings.brand == commandContex[i].actions[j].outputSettings.brand && node.outputs[k].settings.deviceType == commandContex[i].actions[j].outputSettings.deviceType && node.outputs[k].settings.model == commandContex[i].actions[j].outputSettings.model){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }
            if(!outputFound){
              output = {
                icon: "airConditioner",
                name: NODE7.devices[commandContex[i].actions[j].outputSettings.deviceType].brands[commandContex[i].actions[j].outputSettings.brand].devices[commandContex[i].actions[j].outputSettings.model].name,
                parameterId: commandContex[i].actions[j].parameterId,
                type: "IrDevice",
                settings: {
                  brand: commandContex[i].actions[j].outputSettings.brand,
                  deviceType: commandContex[i].actions[j].outputSettings.deviceType,
                  model: commandContex[i].actions[j].outputSettings.model,
                }
              }
            }
          }else{
            for(k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].parameterId == commandContex[i].actions[j].parameterId){
                output = node.outputs[k];
                break;
              }
            }
          }
          loadedCommand.push({
            hub: hub,
            node: node,
            output: output,
            state: state,
            delay: delay
          });
        }
      }
      return loadedCommand;
    },
    getIrDeviceByCommand: function (command) {
      var irDevice = undefined;
      messaging.utility.stripArrayZeros(command);
      if(NODE7.devices.find( (node7, deviceTypeIndex) => {
        if(node7.brands.find( (brand, brandIndex) => {
          if(brand.devices.find( (device, deviceIndex) => {
            if(device.commands.find( (commandPack, commandPackIndex) => {
              if(JSON.stringify(commandPack.command) === JSON.stringify(command)){
                irDevice = {
                  brandIndex: brandIndex,
                  deviceIndex: deviceIndex,
                  commandPackIndex: commandPackIndex,
                  commandPack: commandPack,
                  deviceTypeIndex: deviceTypeIndex,
                }
                return true
              }
            })){
              return true
            }
          })){
            return true
          }
        })){
          return true
        }
      })){
        return irDevice
      }
    },
    addCommand: function () {
      if(this.outputList.length != 0){
        if(!this.showAutomations){
          let hub = this.$store.state.hubs[this.targetHub];
          let node = this.outputList[this.targetOutput].node;
          let output = this.outputList[this.targetOutput].output;
          if(this.isSelectedOutputIR){
            var state = this.acCommandContex;
          }else if(this.isSelectedOutputRF){
            state = {
              rfChannel: this.targetRfCommand,
              rfCommand: output.settings.rfCommands[this.targetRfCommand],
            };
          }else{
            state = this.switchState;
          }
          this.generatedCommand.push(
            {
              hub: hub,
              node: node,
              output: output,
              state: state,
              delay: this.commandDelay,
              type:0
            }
          );
          this.showCreateCommand = false;
          this.commandDelay = 0;
        }else{
          let hub = this.$store.state.hubs[this.targetHub];
          var widget = this.outputList[this.targetOutput].widget;
          var widgetIndex = this.outputList[this.targetOutput].widgetIndex;
          state = this.switchState;
          if(this.generatedCommand.find(command => command.widgetIndex == widgetIndex) !== undefined){
            alert(this.$store.getters.language.texts.CommandCreator_alertDuplicateAutomation);
            return;
          }
          this.generatedCommand.push(
            {
              hub: hub,
              widget: widget,
              widgetIndex: widgetIndex,
              state: state,
              output: {
                type: ''
              },
              type:1
            }
          );
          this.showCreateCommand = false;
        }
      }else if (this.inputList.length != 0){
        if(this.showInputs){
          let hub = this.$store.state.hubs[this.targetHub];
          let node = this.inputList[this.targetInput].node;
          let input = this.inputList[this.targetInput].input;
          let notificationIndex = this.inputList[this.targetInput].notificationIndex;
          let notificationTypeText = this.inputList[this.targetInput].notificationTypeText;
          state = this.switchState;
          this.generatedCommand.push(
            {
              hub: hub,
              node: node,
              input: input,
              state: state,
              output: undefined,
              delay: this.commandDelay,
              notificationIndex:notificationIndex,
              notificationTypeText:notificationTypeText,
              type:2
            }
          );
          this.showCreateCommand = false;
          this.commandDelay = 0;
        }
      }else{
        alert(this.$store.getters.language.texts.CommandCreator_alertNoOutputs);
      }
    },
  },
}
</script>

<style>
  .CommandCreator-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .CommandCreator-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .CommandCreator-commandDelay-button:hover {
    opacity: 0.5;
  }
  .CommandCreator-commandDelay-button:hover {
    opacity: 0.5;
  }
  .CommandCreator-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .CommandCreator-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .CommandCreator-wrapper-commands {
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .CommandCreator-wrapper-commands:first-child {
    margin-top: 0;
  }
  .CommandCreator-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .CommandCreator-wrapper-command {
    height: 40px;
  }
  .CommandCreator-wrapper-commandDelay {
    line-height: 40px;
  }
  .CommandCreator-wrapper-commands-trash {
    top: 5px;
    width: 30px;
    height: 30px;
  }
  .CommandCreator-wrapper-commands-trash.left {
    left: 5px;
  }
  .CommandCreator-wrapper-commands-trash.right {
    right: 5px;
  }
</style>
